module.exports = "https://static.wanderu.com/static/media/hero-header.77546691.jpg";